module.exports = __webpack_public_path__ + "assets/wordpress.777a475c.svg";